<div class="section-basic">
  <!-- app-section-basic-head はこの位置に出力 -->
  <ng-content select="app-section-basic-head"></ng-content>
  <!-- slot -->
  <div class="section-basic-body">
    <ng-content></ng-content>
  </div>
</div>
